
  import {computed, defineComponent, onBeforeUnmount, onMounted, ref} from "vue";
  import ModalDialog from "@/components/ModalDialog.vue";
  import eventBus from "@/eventbus";
  import {MessageTypes} from "@/components/message-types";
  import moment from "moment";
  import EmployeeService from "@/service/EmployeeService";

  export default defineComponent({
    name: "EmployeeDetailsCardDeactivationForm",
    components: {ModalDialog},
    props: {
      editable: {
        type: Boolean,
        default: false
      },
    },
    setup: function (props, {emit}) {
      const showDialog = ref(false);
      let uuid: string | null = null;
      const firstName = ref("");
      const lastName = ref("");
      const openDialog = (payload: { uuid: string, firstName: string, lastName: string }) => {
        uuid = payload.uuid;
        firstName.value = payload.firstName;
        lastName.value = payload.lastName;

        showDialog.value = !!uuid;
      };
      const closeDialog = () => {
        showDialog.value = false;
        uuid = null;
        firstName.value = "";
        lastName.value = "";
      };
      onMounted(() => {
        eventBus.$on(MessageTypes.OPEN_EMPLOYEE_DEACTIVATE, openDialog);
      });
      onBeforeUnmount(() => {
        eventBus.$off(MessageTypes.OPEN_EMPLOYEE_DEACTIVATE, openDialog);
      });
      const isEditable = computed(() => {
        return props.editable;
      });

      const save = () => {
        if (uuid) {
          EmployeeService.deactivateEmployee(uuid)
            .then(response => {
              if (response.status === 204) {
                eventBus.$emit(MessageTypes.SNACKBAR_SUCCESS, "Mitarbeiter deaktiviert");
                emit("deactivated", {activationState: false});
                showDialog.value = false;
              }
            })
            // v3 answers an already inactive employee with a 409, which the global error handler already shows.
            .catch(() => {});
        }
      };
      return {
        showDialog,
        firstName,
        lastName,
        closeDialog,
        isEditable,
        close,
        save
      };
    }
  });
